import React from 'react';
import './App.scss';
import Layout from './components/layouts/Layout';
import Viewer from './containers/Viewer';
import Actions from './containers/Actions';
import DebugViewer from './containers/DebugViewer';
import AppLoading from './containers/AppLoading';
import MissingAssetsBadge from './components/MissingAssetsBadge';

interface IProps {
}

const App: React.FC<IProps> = () => {

  return (
    <>
      <Layout>
        <Viewer />
        <DebugViewer />
        <Actions />
      </Layout>
      <MissingAssetsBadge />
      <AppLoading/>
    </>
  );
};

export default App;
